/**
 * 解决监视预警地图数据与左侧列表数据不一致的问题
 * 预警及雨水情数据统一在地图组件查询（或自动刷新）获取并更新到state中
 * 左侧列表数据展示及查询，从state中获取或筛选 不再去查询API，用以解决查询到的实时数据与地图标注（上5分钟的数据）不一致问题
 */
import {formatDate} from '@/assets/util/common.js'
import eventBus from '@/assets/util/eventBus'

//将数据从对象转换为数组
const objToArr = function (result) {
  if (result instanceof Array) return result

  let list = []
  for (var key in result) {
    list.push(result[key])
  }
  return list
}
//排序并设置NUM属性值
const sort = function (list) {
  list.sort(function (a, b) {
    var ib = parseInt(b['__index'])
    var ia = parseInt(a['__index'])
    return ia - ib
  })
  for (let i = 0; i < list.length; i++) {
    list[i].NUM = i + 1
  }
  return list
}
//获取当前页码的数据
const getPageData = function (result, pageNum, pageSize) {
  return result.filter(item => {
    if (item.NUM > (pageNum - 1) * pageSize && item.NUM <= pageNum * pageSize)
      return true
    else return false
  })
}

export default {
  state: {
    rainInfo: [],
    rainfilterNum: 0, //符合条件的数据条数
    riverInfo: [],
    riverfilterNum: 0,
    rsvrInfo: [],
    rsvrfilterNum: 0,
    warnInfo: [],
    warnfilterNum: 0,
    imgInfo: [],
    imgfilterNum: 0,
    videoInfo: [],
    videofilterNum: 0,
    deviceInfo: [],
    devicefilterNum: 0,
    soilInfo: [],
    soilfilterNum: 0
  },
  getters: {
    filterData: state => (type, conditions) => {
      switch (type) {
        case 'rain':
          //筛选符合条件的数据
          let tmpRainData = state.rainInfo.filter(item => {
            if (
              (conditions.data.stnm == '' ||
                item.STNM.indexOf(conditions.data.stnm) >= 0) &&
              (conditions.data.rvnm == '' ||
                item.RVNM.indexOf(conditions.data.rvnm) >= 0)
              &&
              (conditions.data.frgrd.indexOf(item.FRGRD) >= 0 ||
                (conditions.data.frgrd.indexOf('1') >= 0 &&
                  (item.FRGRD == '2' ||
                    item.FRGRD == '3' ||
                    item.FRGRD ==
                    '4'))) /*FRGRD 1,2,3,4 为水文站 5 山洪站 6 气象站；因此conditions.data.frgrd =1 时 还要筛选 2、3、4*/
            )
              return true
            else return false
          })

          if (conditions.data.level != '') {
            //降雨等级筛选 为空时即全部等级 不需要筛选
            let levelArr = conditions.data.level.split(',')
            tmpRainData = tmpRainData.filter(item => {
              let isMatch = false
              levelArr.forEach(level => {
                let arr = level.split('-')
                if (arr.length == 1 && arr[0] == 0 && arr[0] == item.DRPS)
                  isMatch = true
                else if (arr.length == 1 && arr[0] == 250 && item.DRPS > arr[0])
                  isMatch = true
                else if (
                  arr.length == 2 &&
                  item.DRPS > arr[0] &&
                  item.DRPS <= arr[1]
                )
                  isMatch = true
                else if (
                  arr.length == 2 &&
                  arr[0] == arr[1] &&
                  item.DRPS == arr[0]
                )
                  isMatch = true
              })
              return isMatch
            })
          }

          state.rainfilterNum = tmpRainData.length
          return getPageData(
            sort(tmpRainData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
        case 'river':
          //筛选符合条件的数据
          let tmpRiverData = state.riverInfo.filter(item => {
            if (
              (conditions.data.stnm == '' ||
                item.STNM.indexOf(conditions.data.stnm) >= 0) &&
              (conditions.data.isWarn == '' ||
                (conditions.data.isWarn == '2' && parseFloat(item.ZWARN) > 0) ||
                (conditions.data.isWarn == '3' && parseFloat(item.SWARN) > 0) ||
                (conditions.data.isWarn == '4' && parseFloat(item.GWARN) > 0)) &&
              (conditions.data.rvnm == '' ||
                item.RVNM.indexOf(conditions.data.rvnm) >= 0)
            )
              return true
            else return false
          })
          state.riverfilterNum = tmpRiverData.length
          return getPageData(
            sort(tmpRiverData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
        case 'rsvr':
          //筛选符合条件的数据
          let tmpRsvrData = state.rsvrInfo.filter(item => {
            if (
              (conditions.data.stnm == '' ||
                item.STNM.indexOf(conditions.data.stnm) >= 0) &&
              (!conditions.data.isWarn ||
                (conditions.data.isWarn && parseFloat(item.ZWARN) > 0)) &&
              (conditions.data.rvnm == '' ||
                item.RVNM.indexOf(conditions.data.rvnm) >= 0)
            )
              return true
            else return false
          })

          state.rsvrfilterNum = tmpRsvrData.length
          return getPageData(
            sort(tmpRsvrData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
        case 'warn':
          //筛选符合条件的数据
          let tmpWarnData = state.warnInfo.filter(item => {
            if (
              (conditions.data.warnStatusID == '' ||
                item.WarnStatusID == conditions.data.warnStatusID) &&
              (conditions.data.warnGradeID == '' ||
                item.WarnGradeID == conditions.data.warnGradeID)
            )
              return true
            else return false
          })

          state.warnfilterNum = tmpWarnData.length
          return getPageData(
            sort(tmpWarnData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
        case 'warnComplex':
          //筛选符合条件的数据
          let tmpWarnComplexData = state.warnComplexData.filter(item => {
            if (
              (conditions.data.name == '' ||
                item.WarnNM.indexOf(conditions.data.name) >= 0) && (conditions.data.warnStatusID == '' ||
              item.WarnStatusID == conditions.data.warnStatusID) &&
              (conditions.data.warnGradeID == '' ||
                item.WarnGradeID == conditions.data.warnGradeID)
            )
              return true
            else return false
          })

          state.warnComplexfilterNum = tmpWarnComplexData.length
          return getPageData(
            sort(tmpWarnComplexData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
        case 'img':
          //筛选符合条件的数据
          let tmpImgData = state.imgInfo.filter(item => {
            if (
              conditions.data.stnm == '' ||
              item.STNM.indexOf(conditions.data.stnm) >= 0
            )
              return true
            else return false
          })

          state.imgfilterNum = tmpImgData.length
          return getPageData(
            sort(tmpImgData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
        case 'video':
          //筛选符合条件的数据
          let tmpVideoData = state.videoInfo.filter(item => {
            if (
              conditions.data.stnm == '' ||
              item.STNM.indexOf(conditions.data.stnm) >= 0
            )
              return true
            else return false
          })

          state.videofilterNum = tmpVideoData.length
          return getPageData(
            sort(tmpVideoData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
        case 'device':
          //筛选符合条件的数据
          let tmpDeviceData = state.deviceInfo.filter(item => {
            if (
              (conditions.data.stnm == '' ||
                item.STNM.indexOf(conditions.data.stnm) >= 0) &&
              (conditions.data.frgrd.indexOf(item.FRGRD) >= 0 ||
                (conditions.data.frgrd.indexOf('1') >= 0 &&
                  (item.FRGRD == '2' ||
                    item.FRGRD == '3' ||
                    item.FRGRD ==
                    '4'))) /*FRGRD 1,2,3,4 为水文站 5 山洪站 6 气象站；因此conditions.data.frgrd =1 时 还要筛选 2、3、4*/
            )
              return true
            else return false
          })
          tmpDeviceData = tmpDeviceData.filter(item => {
            if (
              (conditions.data.stnm == '' ||
                item.STNM.indexOf(conditions.data.stnm) >= 0) &&
              (conditions.data.status == '' ||
                (conditions.data.status == '0' &&
                  (item.REPORT8 == '0' || item.REPORT24 == '0')) ||
                (conditions.data.status == '1' &&
                  item.REPORT8 == '1' &&
                  item.REPORT24 == '1'))
            )
              return true
            else return false
          })
          state.devicefilterNum = tmpDeviceData.length
          return getPageData(
            sort(tmpDeviceData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
        case 'soil':
          //筛选符合条件的数据
          let tmpSoilData = state.soilInfo.filter(item => {
            if (
              conditions.data.stnm == '' ||
              item.STNM.indexOf(conditions.data.stnm) >= 0
            )
              return true
            else return false
          })

          state.soilfilterNum = tmpSoilData.length
          return getPageData(
            sort(tmpSoilData),
            conditions.pageNum,
            conditions.pageSize
          )
          break
      }
    }
  },
  mutations: {
    updateData(state, payload) {
      switch (payload.type) {
        case 'rain':
          state.rainInfo = objToArr(payload.data)
          eventBus.$emit('mapRainUpdate')
          break
        case 'river':
          state.riverInfo = objToArr(payload.data)
          eventBus.$emit('mapRiverUpdate')
          break
        case 'rsvr':
          state.rsvrInfo = objToArr(payload.data)
          eventBus.$emit('mapRsvrUpdate')
          break
        case 'warn':
          let warnData = objToArr(payload.data)
          warnData.forEach(item => {
            item.WarnSTM = formatDate(item.WarnSTM)
            switch (item.WarnGradeID) {
              case 4:
                item.WarnGrade = '立即转移'
                break
              case 5:
                item.WarnGrade = '准备转移'
                break
            }
            switch (item.WarnStatusID) {
              case 0:
                item.WarnStatus = '新产生'
                break
              case 10:
                item.WarnStatus = '已内部预警'
                break
              case 20:
                item.WarnStatus = '已外部预警'
                break
              case 30:
                item.WarnStatus = '关闭预警'
                break
            }
            let str = item.WarnGrade.slice(0, 2) + ' | '
            if (item.WarnStatus == '新产生') {
              str += item.WarnStatus.slice(0, 1)
            } else {
              str += item.WarnStatus.slice(1, 2)
            }
            item.DES = str
          })
          state.warnInfo = warnData
          eventBus.$emit('mapWarnUpdate')
          break
        case 'warnComplex':
          let warnComplexData = objToArr(payload.data)
          warnComplexData.forEach(item => {
            let str = ''
            if (item.WarnStatusNM == '新产生') {
              str = item.WarnStatusNM.slice(0, 1)
            } else {
              str = item.WarnStatusNM.slice(1, 2)
            }
            item.DES = item.WarnGradeNM + '|' + str
          })
          state.warnComplexData = warnComplexData
          eventBus.$emit('warnComplexUpdate')
          break
        case 'img':
          state.imgInfo = objToArr(payload.data)
          eventBus.$emit('mapImgUpdate')
          break
        case 'video':
          state.videoInfo = objToArr(payload.data)
          eventBus.$emit('mapVideoUpdate')
          break
        case 'device':
          let tmpData = objToArr(payload.data)
          tmpData.forEach(item => {
            switch (item.FRGRD) {
              case '1':
              case '2':
              case '3':
              case '4':
                item.STTP = '水文站'
                break
              case '5':
                item.STTP = window.HTCFG.shStationNm
                break
              case '6':
                item.STTP = '气象站'
                break
              case '7':
                item.STTP = '新建站'
                break
            }
          })
          state.deviceInfo = tmpData
          eventBus.$emit('mapDeviceUpdate')
          break
        case 'soil':
          state.soilInfo = objToArr(payload.data)
          eventBus.$emit('mapSoilUpdate')
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/warnmonitor/index.js